export default {
    initialized: state => state.initialized,
    getacounts: state => state.acounts,
    // 所选游戏id
    getgameid: state => state.gameid
    
}